import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { API_ROOT } from './config'

Vue.use(VueAxios, axios)

// global
export const postConfirmEmail = (data) => Vue.axios.post(API_ROOT + 'v3/users/confirm_email', data)
export const postResetUserPassword = (data) => Vue.axios.post(API_ROOT + 'v3/users/reset_password', data)
// user
export const getUserToken = (config) => Vue.axios.get(API_ROOT + 'users/current_user', { headers: config })
export const postUser = (data) => Vue.axios.post(API_ROOT + 'users/sign_in', data)
export const deleteUser = (config) => Vue.axios.delete(API_ROOT + 'users/sign_out', { headers: config })



// WEBPACK FOOTER //
// ./src/api/index.js